/* React */
import React from 'react';

/* Assets */
import OwlWin from '../../assets/owl_win.png';
import OwlLose from '../../assets/owl_lose.png';

/* Hooks */
import { useWordle } from '../../../WordleContext';

/* Styles */
import { ModalResult } from './styles';

interface Props {
  isVisible: boolean
  answer: string
  definition: string
  result: string
}

export const Results: React.FC<Props> = ({ isVisible, answer, definition, result }: Props) => {

  /* Context */
  const {
    setOpenModalResult
  } = useWordle();

  return (
    <ModalResult isVisible={isVisible}>
      {
        result === "WIN" || localStorage.getItem('@PortalWordle:gameStatus') === "WIN"
          ?
          <main>
            <h1>PARABÉNS!</h1>
            <h2>Você acertou a palavra do dia!</h2>
            <h2>A resposta é:</h2>
            <div>
              <span>{answer}!</span>
              <p>E sua definição é:</p>
              <p>{definition}</p>
              <img src={OwlWin} alt="Desenho de uma coruja feliz, pulando de alegria por sua
               vitória no jogo" />
            </div>
            <p>Volte amanhã para tentar uma outra palavra!</p>
            <button onClick={() => setOpenModalResult(false)}>Ok!</button>
          </main>

          :
          
          <main>
            <h1>Poxa, não foi dessa vez!</h1>
            <h2>Você não acertou a palavra do dia!</h2>
            <h2>A resposta correta era:</h2>
            <div>
              <span>{answer}!</span>
              <p>E sua definição é:</p>
              <p>{definition}</p>
              <img src={OwlLose} alt="Desenho de uma coruja deprimida pelo resultado do jogo" />
            </div>
            <p>Volte amanhã para tentar uma outra palavra!</p>
            <button onClick={() => setOpenModalResult(false)}>Ok!</button>
          </main>
      }
    </ModalResult>
  );
};
